import { motion } from "framer-motion";

// Fade + rise on scroll-into-view
export const Reveal = ({ children, delay = 0, y = 26, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked, line-by-line kinetic reveal (splits words; wrap words in lines)
export const KineticLines = ({ lines, className = "", delay = 0 }) => {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12, delayChildren: delay } },
  };
  const line = {
    hidden: { y: "115%" },
    show: { y: "0%", transition: { duration: 1.05, ease: [0.16, 1, 0.3, 1] } },
  };
  return (
    <motion.span
      className={className}
      variants={container}
      initial="hidden"
      animate="show"
    >
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span variants={line} className="block">
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
